<div class="limiter main-font">
    <div class="container-login100">
        <div class="wrap-login100">
            <div class="login100-pic">
                <img [src]="logo" alt="img">
            </div>

            <form [formGroup]="form" #ngForm="ngForm" (ngSubmit)="onSubmit()" class="login100-form validate-form">
                <span class="login100-form-title">
                    Effettua il Login
                </span>

                <div class="wrap-input100 validate-input mb-2" data-validate="Valid email is required">
                    <input class="input100" type="email" name="email" formControlName="email" placeholder="Email">
                    <span class="symbol-input100 icon">
                        <mat-icon>mail</mat-icon>
                    </span>
                </div>

                <div class="wrap-input100 validate-input mb-2" data-validate="Password is required">
                    <input class="input100" [type]="showPassword ? 'text' : 'password'" name="pass" formControlName="password" placeholder="Password">
                    <span class="eye-icon" (click)="switchPassword()">
                      <mat-icon class="material-icons-outlined" [ngClass]="{'open-eye': showPassword, 'closed-eye': !showPassword}"></mat-icon>
                    </span>
                    <span class="symbol-input100 icon">
                      <mat-icon>lock</mat-icon>
                    </span>
                </div>

                <div class="d-flex align-items-center mt-3 ms-3">
                    <input type="checkbox" name="remember_me" formControlName="remember_me" id="remember_me" class="me-2 checkbox-login" />
                    <p>Ricordami</p>
                </div>

                <div class="position-relative">
                    <p class="text-center w-100 fs-error position-absolute">{{ error }}</p>
                </div>

                <div class="container-login100-form-btn mt-3">
                    <button class="login100-form-btn" type="submit">
                        Login
                    </button>
                </div>

                <div class="text-center p-t-12">
                    <a class="txt2" routerLink="/reset-password" target="_blank">
                        Password dimenticata?
                    </a> 
                </div>

                <div class="text-center p-t-140">
                </div>
            </form>
        </div>
    </div>
</div>
